import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { acceptFriendRequest, rejectFriendRequest } from "../Data/FriendshipHelpers.jsx";

const FriendRequests = () => {
  const [requests, setRequests] = useState([]);
  const [currentUser, setCurrentUser] = useState(null); 
  const [processingId, setProcessingId] = useState(null);

  useEffect(() => {
    const fetchCurrentUser = async () => {
      const { data: sessionData, error } = await supabase.auth.getSession();
      if (error) {
        console.error("Error fetching session:", error);
        return;
      }
      if (sessionData && sessionData.session) {
        const authUser = sessionData.session.user;

        const { data: userData, error: userError } = await supabase
          .from("users")
          .select("*")
          .eq("public_user_id", authUser.id)
          .single();

        if (userError) {
          console.error("Error fetching user from users table:", userError);
          return;
        }


        setCurrentUser(userData);
        fetchFriendRequests(userData.id);
      } else {
       return
      }
    };

    fetchCurrentUser();
  }, []);

  const fetchFriendRequests = async (userId) => {
    console.log("Fetching friend requests for userId:", userId);

    const { data: friendRequests, error } = await supabase
      .from("friend_requests")
      .select(
        `
        id,
        from_user,
        to_user,
        status,
        users!friend_requests_from_user_fkey (username)
      `
      )
      .eq("to_user", userId)
      .eq("status", "pending");

    if (error) {
      console.error("Error fetching friend requests:", error);
    } else {
      console.log("Friend requests fetched:", friendRequests);
      setRequests(friendRequests);
    }
  };

  const handleAccept = async (requestId) => {
    setProcessingId(requestId);
    try {
      const result = await acceptFriendRequest(requestId, currentUser.id);
      if (result.success) {
        setRequests(requests.filter((request) => request.id !== requestId));
      } else {
        console.error("Error accepting friend request:", result.error);
        alert(result.error || "Failed to accept friend request");
      }
    } catch (error) {
      console.error("Unexpected error accepting friend request:", error);
      alert("An unexpected error occurred");
    } finally {
      setProcessingId(null);
    }
  };

  const handleRejectFriend = async (requestId) => {
    try {
      const result = await rejectFriendRequest(requestId, currentUser.id);
      if (result.success) {
        setRequests(requests.filter((request) => request.id !== requestId));
      } else {
        console.error("Error rejecting friend request:", result.error);
        alert(result.error || "Failed to reject friend request");
      }
    } catch (error) {
      console.error("Unexpected error rejecting friend request:", error);
      alert("An unexpected error occurred");
    }
  };

  return (
    <div className="container mt-3">
      <div className="row">
        {requests.length > 0 ? (
          requests.map((request) => (
            <div key={request.id} className="col-md-4 mb-3">
              <div className="card text-center">
                <div className="card-body">
                  <h5 className="card-title text-info">
                    {request.users.username}
                  </h5>
                  <p className="card-text">Would like to be your friend</p>
<button
  onClick={() => handleAccept(request.id)}
  className="btn btn-primary mr-2"
  disabled={processingId === request.id}
>
  {processingId === request.id ? "Accepting..." : "Accept"}
</button>
                  <button
                    onClick={() => handleRejectFriend(request.id)}
                    className="btn btn-secondary mx-2"
                  >
                    Decline
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div>
            <h2 className="text-center text-info">
              
            </h2>
          </div>
        )}
      </div>
    </div>
  );
};

const GiftCardNotifications = () => {
  const [giftNotifications, setGiftNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    const fetchGiftNotifications = async () => {
      setLoading(true);
      const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
      if (sessionError || !sessionData?.session?.user) {
        setLoading(false);
        return;
      }

      const authUser = sessionData.session.user;
      const { data: currentUser, error: currentUserError } = await supabase
        .from("users")
        .select("id")
        .eq("public_user_id", authUser.id)
        .single();

      if (currentUserError || !currentUser) {
        console.error("Error fetching current user for gift notifications:", currentUserError);
        setLoading(false);
        return;
      }

      setCurrentUserId(currentUser.id);

      const { data, error } = await supabase
        .from("gift_card_notifications")
        .select(
          `
          id,
          recipient_user_id,
          bet_id,
          gift_vendor,
          gift_amount,
          gift_code,
          message,
          created_at,
          users!gift_card_notifications_sender_user_id_fkey (username)
        `
        )
        .eq("recipient_user_id", currentUser.id)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Error fetching gift card notifications:", error);
        setLoading(false);
        return;
      }

      setGiftNotifications(data || []);
      setLoading(false);
    };

    fetchGiftNotifications();
  }, []);

  const handleDeleteGiftNotification = async (notificationId) => {
    setDeletingId(notificationId);

    const { error } = await supabase
      .from("gift_card_notifications")
      .delete()
      .eq("id", notificationId);

    if (error) {
      console.error("Error deleting gift notification:", error);
      alert("Could not remove this e-gift entry.");
      setDeletingId(null);
      return;
    }

    setGiftNotifications((prev) => prev.filter((item) => item.id !== notificationId));
    setDeletingId(null);
  };

  return (
    <div className="container mt-3">
      <h3 className="text-center text-info mb-3">E-Gift Deliveries</h3>
      <div className="row">
        {loading ? (
          <p className="text-center text-info">Loading e-gift deliveries...</p>
        ) : giftNotifications.length === 0 ? (
          <p className="text-center text-info">No e-gift deliveries received yet.</p>
        ) : (
          giftNotifications.map((item) => (
            <div key={item.id} className="col-md-6 mb-3">
              <div className="card">
                <div className="card-body text-start">
                  <h5 className="card-title text-success">{item.gift_vendor} E-Gift Card</h5>
                  <p className="card-text mb-1">
                    <strong>From:</strong> {item.users?.username || "Friend"}
                  </p>
                  <p className="card-text mb-1">
                    <strong>Amount:</strong> {item.gift_amount || "N/A"}
                  </p>
                  <p className="card-text mb-1">
                    <strong>Redemption Details:</strong> {item.gift_code}
                  </p>
                  <p className="card-text mb-1">
                    <strong>Bet ID:</strong> {item.bet_id}
                  </p>
                  <p className="card-text">
                    <small className="text-muted">
                      {new Date(item.created_at).toLocaleString()}
                    </small>
                  </p>
                  {item.recipient_user_id === currentUserId && (
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => handleDeleteGiftNotification(item.id)}
                      disabled={deletingId === item.id}
                    >
                      {deletingId === item.id ? "Removing..." : "Delete After Claiming"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export { FriendRequests, GiftCardNotifications };
